// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manufacturer-item {
    margin: 10px;
}


.manufacturer-list {
    display: flex;
    flex-direction: column;
    margin: 1px;
}

.manufacturer-tile {
    display: flex;
    flex-direction: row;
}

.manufacturer-select {
    margin: 5px;
    align-items: center;
    justify-content: center ;
    width: 100%;
}

.manufacturer-page {
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    width: 100%;
}
.add-manufacturer-column {
    align-items: center;
    min-width: 80%;
    display: flex;
    flex-direction: column;
}
.standard-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.send-request-tile {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 5px;
}

.existing-cooperatios-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    width:100%
}
.search-request-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-self: center;
    justify-content: flex-start;
    width: 100%;
}
.cooperation-request-conatiner {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    margin: 5px;
}
.request-container {
    display:flex;
    min-width: 50vw;
    max-width: 95vw;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.request-tile{
    display: flex;
    flex-direction: row;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/css/pages/AddAssociatedManufacturer.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".manufacturer-item {\r\n    margin: 10px;\r\n}\r\n\r\n\r\n.manufacturer-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 1px;\r\n}\r\n\r\n.manufacturer-tile {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.manufacturer-select {\r\n    margin: 5px;\r\n    align-items: center;\r\n    justify-content: center ;\r\n    width: 100%;\r\n}\r\n\r\n.manufacturer-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: center;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n.add-manufacturer-column {\r\n    align-items: center;\r\n    min-width: 80%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.standard-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.send-request-tile {\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.existing-cooperatios-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    width:100%\r\n}\r\n.search-request-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-self: center;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n}\r\n.cooperation-request-conatiner {\r\n    width: 50%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-self: flex-start;\r\n    margin: 5px;\r\n}\r\n.request-container {\r\n    display:flex;\r\n    min-width: 50vw;\r\n    max-width: 95vw;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.request-tile{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
